import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
export default function NotFound() {
    return /*#__PURE__*/ _jsx("div", {
        className: "min-h-[60vh] flex items-center justify-center bg-stone-50",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "text-center",
            children: [
                /*#__PURE__*/ _jsx("h1", {
                    className: "font-heading text-6xl font-bold text-stone-900 mb-2",
                    children: "404"
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "text-xl text-stone-500 mb-8",
                    children: "Page not found"
                }),
                /*#__PURE__*/ _jsx(Link, {
                    to: "/",
                    className: "inline-block bg-stone-900 text-white px-6 py-3 text-xs font-semibold uppercase tracking-wider hover:bg-stone-700",
                    children: "Return Home"
                })
            ]
        })
    });
}
